<script setup lang="ts">
defineProps({
	width: {
		type: [String, Number],
		default: '',
	},
	height: {
		type: [String, Number],
		default: '46',
	},
	loading: {
		type: Boolean,
		default: false,
	},
});

const slots = defineSlots();
const hasSlotContent = computed(() => !!slots.default);
</script>

<template>
	<template v-if="hasSlotContent">
		<VSkeletonLoader
			class="text-input-loader"
			type="list-item"
			:loading="loading"
			:width="width"
			:height="height"
		>
			<slot />
		</VSkeletonLoader>
	</template>
	<template v-else>
		<VSkeletonLoader
			class="text-input-loader"
			type="list-item"
			:loading="loading"
			:width="width"
			:height="height"
		/>
	</template>
</template>

<style scoped lang="scss">
.text-input-loader {
	:deep(.v-skeleton-loader__bone) {
		height: inherit;
		max-width: inherit;
		margin: 0;
	}
}
</style>
